exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  position: relative; }\n\n.showStep {\n  display: block !important; }\n\n.wizard-steps {\n  display: none; }\n\n.left-bar {\n  background: #f2f2f2;\n  width: 25px;\n  transition: width 0.3s ease-in; }\n  .left-bar .btn-expand {\n    width: 25px;\n    height: 25px;\n    text-align: center;\n    color: #999;\n    background: rgba(136, 136, 136, 0.1);\n    cursor: pointer; }\n  .left-bar .circle-container {\n    width: 200px;\n    overflow: hidden; }\n  .left-bar .circle {\n    width: 15px;\n    height: 15px;\n    margin: 5px;\n    border-radius: 50%;\n    background: #f2f2f2;\n    border: 1px solid #c9c9c9;\n    transition: background .3s ease-out; }\n  .left-bar .circle-select {\n    background: #015251; }\n\n.left-bar-expand {\n  width: 200px; }\n\n.step {\n  width: 30px;\n  height: 30px;\n  padding: 5px;\n  margin: 5px;\n  background: #f2f2f2;\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/form/core/component/form-wizard/form-wizard.component.scss
// module id = 922
// module chunks = 0